import React, { Fragment, useCallback } from 'react'

import Router from 'next/router'

import { ProgressBar, StepError } from '..'
import { setMatchMakerQuestion } from '../../../../services/match-maker'

const SixthStep = ({ state, dispatch, goToPreviousStep, maxSteps }) => {
  const finishMatchMaking = useCallback(async () => {
    dispatch({ type: 'set_status', payload: 'loading' })
    try {
      const matchmakingId = localStorage.getItem('idMatchmaking')
      if (matchmakingId) {
        const parsedMatchmakingId = JSON.parse(matchmakingId)
        localStorage.setItem(
          'idMatchmaking',
          JSON.stringify([...parsedMatchmakingId, state.id_session])
        )
      } else {
        localStorage.setItem('idMatchmaking', JSON.stringify([state.id_session]))
      }
      await setMatchMakerQuestion({
        id_session: state.id_session,
        answers: [{ question: state.questions[10].id, answer: state.form_values.help_type }]
      })
      localStorage.removeItem('@vittude:match-maker')
      Router.push(
        `/encontre-seu-psicologo/resultados?id_session=${state.id_session}&location_preference=${state.form_values.location_preference}`
      )
    } catch {
      dispatch({ type: 'set_status', payload: 'error' })
    }
  }, [state.form_values.help_type])

  if (state.status === 'error') {
    return <StepError stepImage='/static/mages/match-maker/06.png' submitStep={finishMatchMaking} />
  }

  return (
    <Fragment>
      <div className='step__illustration lg:hidden'>
        <img src='/static/images/match-maker/06.png' width='100%' />
      </div>
      <div className='step__question'>
        <p className='step__question__title'>Você já fez terapia anteriormente?</p>
        <p className='step__question__description'>
          Como encontrou seu psicólogo? Você fez terapia há quanto tempo?
        </p>
        <div className='step__question__template mb-5'>
          <input
            className='match-maker-text-input mb-5'
            placeholder='Conte como foi...'
            value={state.form_values.help_type}
            onChange={e => dispatch({ type: 'set_help_type', payload: e.target.value })}
          />
        </div>
        <div className='step__question__info mt-5'>
          <div className='step__question__info__next-step-container'>
            <div className='step__question__info__next-step-container__navigation'>
              <button
                className='button-verm-leaked match-maker-button mr-3'
                onClick={goToPreviousStep}
              >
                Voltar
              </button>
              <button
                className='button-verm match-maker-button'
                onClick={finishMatchMaking}
                id='finish-matchmaking'
              >
                Concluir
              </button>
            </div>
            {state.current_step > 0 && (
              <ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export { SixthStep }
